/*
 * Reliance — « Votre routine » du diagnostic visage (sections/rel-diagnostic-routine.liquid, E.2r2).
 *  - nettoyants : sélecteur de volume par carte (variante, prix, récap) ;
 *  - ligne 03 : reflète la crème de l'onglet ouvert du composeur « Choisir sa crème » (assets/rel-cremes.js,
 *    événement rel-cremes:change) ; son bouton coche / décoche la crème dans le composeur, qui reste la source ;
 *  - titres et notes « sur-mesure » / « actives » selon l'onglet du composeur.
 * Sélection, total, barre, sessionStorage et panier réel : assets/rel-selection-cart.js.
 * Contrat data-* : en tête de la section.
 */
(function () {
  if (window.relRoutineInit) return;
  window.relRoutineInit = true;

  function all(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function parse(json) {
    try {
      return JSON.parse(json || '[]');
    } catch (e) {
      return [];
    }
  }

  function init(root) {
    if (root.relRoutine) return;
    var composer = document.querySelector('[data-rel-cremes]');
    var soinRow = root.querySelector('[data-rel-routine-soin-row]');
    var soin = root.querySelector('[data-rel-selection-item="soin"]');
    var soinToggle = root.querySelector('[data-rel-routine-soin-toggle]');
    var cleansers = all(root, '[data-variants]');
    var currentTab = 'surmesure';

    /* Sans composeur, pas de ligne 03 : la barre se décolle après la dernière ligne visible. */
    if (!composer && soinRow) {
      soinRow.removeAttribute('data-rel-routine-last');
      var steps = all(root, '.rel-routine-step:not([data-rel-routine-soin-row])');
      if (steps.length) steps[steps.length - 1].setAttribute('data-rel-routine-last', '');
    }

    /* ---------- nettoyants : volume ---------- */
    function setVolume(card, id) {
      var variant = parse(card.getAttribute('data-variants')).filter(function (v) {
        return String(v.id) === String(id);
      })[0];
      if (!variant) return false;
      card.setAttribute('data-available', variant.available ? 'true' : 'false');
      card.setAttribute('data-variant-id', variant.available ? variant.id : '');
      card.setAttribute('data-price', variant.price);
      card.setAttribute('data-summary', (card.getAttribute('data-name') || '') + ' ' + variant.label);
      card.setAttribute('data-volume', variant.id);
      all(card, '[data-rel-routine-volume]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-rel-routine-volume') === String(variant.id) ? 'true' : 'false');
      });
      var price = card.querySelector('[data-rel-routine-price]');
      if (price) price.textContent = variant.available ? variant.price_label : card.getAttribute('data-unavailable-label') || '';
      return true;
    }

    cleansers.forEach(function (card) {
      all(card, '[data-rel-routine-volume]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (setVolume(card, b.getAttribute('data-rel-routine-volume')) && root.relSelection) root.relSelection.refresh();
        });
      });
    });

    /* ---------- ligne 03 : crème du composeur ---------- */
    function renderTab(tab) {
      currentTab = tab === 'actives' ? 'actives' : 'surmesure';
      all(root, '[data-rel-routine-when]').forEach(function (el) {
        el.hidden = el.getAttribute('data-rel-routine-when') !== currentTab;
      });
    }

    function syncSoin(data, tab) {
      renderTab(tab);
      if (!soin || !soinRow) return;
      soinRow.hidden = !data;
      if (!data) return;
      soin.setAttribute('data-available', data.available ? 'true' : 'false');
      soin.setAttribute('data-variant-id', data.available ? data.variantId : '');
      soin.setAttribute('data-price', data.price || '0');
      soin.setAttribute('data-summary', data.summary || data.title || '');
      soin.setAttribute('data-item-title', data.title || '');
      var name = soin.querySelector('[data-rel-routine-soin-name]');
      var who = soin.querySelector('[data-rel-routine-soin-who]');
      var price = soin.querySelector('[data-rel-routine-soin-price]');
      var media = soin.querySelector('[data-rel-routine-soin-media]');
      if (name) name.textContent = data.title || '';
      if (who) who.textContent = data.who || '';
      if (price) price.textContent = data.available ? data.priceLabel : soin.getAttribute('data-unavailable-label') || '';
      // Bouton « Aperçu » (rel-quickview.js) : produit de la crème choisie
      var preview = soin.querySelector('[data-rel-quickview]');
      if (preview) {
        if (!preview.hasAttribute('data-label-template')) preview.setAttribute('data-label-template', preview.getAttribute('aria-label') || '');
        preview.hidden = !data.handle;
        preview.setAttribute('data-rel-quickview', data.handle || '');
        preview.setAttribute('aria-label', preview.getAttribute('data-label-template').replace('[title]', data.title || ''));
      }
      if (media) {
        var img = media.querySelector('img');
        var missing = media.querySelector('.rel-routine__missing');
        if (data.image) {
          if (!img) {
            img = document.createElement('img');
            img.alt = '';
            img.loading = 'lazy';
            img.width = 200;
            img.height = 200;
            media.appendChild(img);
          }
          if (img.getAttribute('src') !== data.image) img.src = data.image;
          img.hidden = false;
          if (missing) missing.hidden = true;
        } else {
          if (img) img.hidden = true;
          if (missing) missing.hidden = false;
        }
      }
      if (soinToggle) {
        var on = !!data.picked;
        var text = data.available
          ? soinToggle.getAttribute(on ? 'data-label-added' : 'data-label-add')
          : soin.getAttribute('data-unavailable-label') || '';
        soinToggle.disabled = !data.available;
        soinToggle.setAttribute('aria-pressed', on ? 'true' : 'false');
        soinToggle.textContent = text;
        var template = soinToggle.getAttribute('data-label-template');
        if (template && data.title) {
          soinToggle.setAttribute('aria-label', template.replace('[action]', text.replace(/^✓\s*/, '')).replace('[product]', data.title));
        }
      }
      if (root.relSelection) root.relSelection.select('soin', !!data.picked && data.available);
    }

    if (soinToggle) {
      soinToggle.addEventListener('click', function () {
        if (composer && composer.relCremes) composer.relCremes.toggleCurrent();
      });
    }

    document.addEventListener('rel-cremes:change', function (event) {
      var detail = event.detail || {};
      syncSoin(detail.soin || null, detail.tab);
    });

    /* ---------- démarrage ---------- */
    function saveState() {
      var volumes = {};
      cleansers.forEach(function (card) {
        var key = card.getAttribute('data-rel-selection-item');
        if (card.getAttribute('data-volume')) volumes[key] = card.getAttribute('data-volume');
      });
      return { volumes: volumes };
    }

    function restoreState(saved) {
      var volumes = (saved && saved.volumes) || {};
      cleansers.forEach(function (card) {
        var id = volumes[card.getAttribute('data-rel-selection-item')];
        if (id) setVolume(card, id);
      });
    }

    /* Diagnostic (« Voir ma routine ») : coche exactement les articles donnés (hors crème, tenue par le composeur),
       avec le volume demandé pour les nettoyants. keys = clés d'articles ; volumes = { clé: id de variante }. */
    function applyReco(keys, volumes) {
      var selection = root.relSelection;
      if (!selection) return;
      volumes = volumes || {};
      cleansers.forEach(function (card) {
        var id = volumes[card.getAttribute('data-rel-selection-item')];
        if (id) setVolume(card, id);
      });
      all(root, '[data-rel-selection-item]').forEach(function (el) {
        var key = el.getAttribute('data-rel-selection-item');
        if (key !== 'soin') selection.select(key, keys.indexOf(key) !== -1);
      });
    }

    /* Boutons hors de la section (cartes « Deux sérums », E.2r3) : button[data-rel-routine-link="{clé}"] coche /
       décoche l'article de la routine ; libellés data-label-add / data-label-added. Masqués si l'article manque. */
    var links = all(document, '[data-rel-routine-link]');

    function renderLinks() {
      var picked = {};
      if (root.relSelection) {
        root.relSelection.getSelection().forEach(function (item) {
          picked[item.key] = true;
        });
      }
      links.forEach(function (button) {
        var key = button.getAttribute('data-rel-routine-link');
        var item = root.querySelector('[data-rel-selection-item="' + key + '"]');
        button.hidden = !item;
        if (!item) return;
        var on = !!picked[key];
        button.disabled = item.getAttribute('data-available') !== 'true';
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
        button.textContent = button.getAttribute(on ? 'data-label-added' : 'data-label-add') || button.textContent;
      });
    }

    links.forEach(function (button) {
      button.addEventListener('click', function () {
        if (root.relSelection) root.relSelection.toggle(button.getAttribute('data-rel-routine-link'));
      });
    });
    root.addEventListener('rel-selection:change', renderLinks);

    root.relRoutine = { syncSoin: syncSoin, applyReco: applyReco };

    if (window.RelSelectionCart) {
      window.RelSelectionCart.init(root, { saveState: saveState, restoreState: restoreState });
    }
    renderLinks();
    /* La crème vient toujours du composeur (sa propre sauvegarde), jamais de celle de la routine. */
    if (composer && composer.relCremes) {
      var state = composer.relCremes.getState();
      syncSoin(state.soin, state.tab);
    } else {
      syncSoin(null, 'surmesure');
    }
  }

  function boot() {
    document.querySelectorAll('[data-rel-routine]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
